<div class="forgot-password overlay" *ngIf="this._UiHelper.forgotPass" #outsideOverlay>
  <div class="modal-inside" outsideListener (clickOutside)="handleOutside($event)">
    <div class="modal-close d-flex p-2">
      <div class="empty-space"></div>
      <div class="title my-auto forgot-pass-title">
        {{ 'Forgot_Password' | t }}
      </div>
      <div class="close-modal d-flex ml-auto">
        <div class="cls mx-auto" (click)="this._UiHelper.toogleForgotPass()">✕</div>
      </div>
    </div>
    <span class="forgot-text">{{ 'Enter_email_address_request_password_and_use_new_password_from_the_email' | t }}</span>
    <form class="forgot-form" [formGroup]="forgotPasswordDatas">
      <inputb3
        formControlName="email"
        [fID]="'email'"
        fErrorText="{{ 'Please_enter_a_valid_mail_address' | t }}"
        fPlaceholder="Email"
        fInputType="text"
        extraClass="forgotPass"></inputb3>
      <div class="date-container" style="padding-left: 30px; padding-top: 20px; width: 100%; padding-right: 30px">
        <div class="sub-text" style="font-style: normal; font-size: 13px; font-weight: 500; padding-left: 10px; margin-bottom: 5px">
          {{ 'b3000_DateOfBirth' | t }}
        </div>
        <div class="form-b3 form-field-b3 birthDayForm">
          <input formControlName="birthDay" type="date" id="start" placeholder="{{ 'b3000_DateOfBirth' | t }}" name="trip-start" [value]="startDate" />
        </div>
      </div>
      <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
        <ng-container *ngSwitchCase="'wettarena'">
          <div class="btn colored blue login-dropdown-btn" style="margin-top: 20px" *ngIf="forgotPasswordDatas.valid; else noValid" (click)="submitForgotPasswordData2()">
            <div class="login-button-text">{{ 'Confirm' | t }}</div>
          </div>
          <ng-template #noValid>
            <div class="btn colored blue login-dropdown-btn" style="opacity: 0.5; margin-top: 20px">
              <div class="login-button-text">{{ 'Confirm' | t }}</div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'b500'">
          <div class="btn colored blue login-dropdown-btn" style="margin-top: 20px" *ngIf="forgotPasswordDatas.valid; else noValid" (click)="submitForgotPasswordData2()">
            <div class="login-button-text">{{ 'Confirm' | t }}</div>
          </div>
          <ng-template #noValid>
            <div class="btn colored blue login-dropdown-btn" style="opacity: 0.5; margin-top: 20px">
              <div class="login-button-text">{{ 'Confirm' | t }}</div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div
            class="btn colored login-dropdown-btn"
            style="margin-top: 20px; min-height: 36px !important"
            *ngIf="forgotPasswordDatas.valid; else noValid"
            (click)="submitForgotPasswordData2()">
            <div class="login-button-text">{{ 'Confirm' | t }}</div>
          </div>
          <ng-template #noValid>
            <div class="btn colored login-dropdown-btn" style="opacity: 0.5; margin-top: 20px; min-height: 36px !important">
              <div class="login-button-text">{{ 'Confirm' | t }}</div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
    </form>
  </div>
</div>
